import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)`
  padding: 8px 16px;
  text-align: center;
  width: 70px;
  min-width: fit-content;
`;
